import api from '../utils/baseUrl';

class CountryService {
    async getCountries() {
        try {
            const response = await api.get('countries');
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            console.error('Error fetching countries:', error);
            return [];
        }
    }
}

export default new CountryService();